import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        isTrial: '=',
        selectedLanguage: '=',
        showCorrectAnswers: '=',
        showTesteesAnswers: '=',
        formSubmission: '=',
        showPointsAwarded: '='
    },
    template: `
        <div class="heading01">
            <div class="" ng-bind-html="vm.getQuestionName() | isRequired: vm.question.formQuestions[0].isRequired"></div>
            <ul class="metablock" ng-if="vm.showPointsAwarded">
                <li>
                    <div class="label">{{ 'quiz.Points awarded' | translate }}</div>
                    <div class="value">{{ vm.getPointsObtained() }} / {{ vm.question.score }}</div>
                </li>
            </ul>
        </div>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <p ng-if="vm.showCorrectAnswers || vm.showTesteesAnswers" class="answer">
            {{ 'forms.Your answer' | translate }}:
            <strong ng-if="vm.form.answers[vm.question.id].answerId" class="positive">
                {{ vm.form.answers[vm.question.id].answerText }}
            </strong>
            <strong ng-if="!vm.form.answers[vm.question.id].answerId" class="negative">
                {{ vm.form.answers[vm.question.id].answerText }}
            </strong>
        </p>
        <textarea
            ng-disabled="vm.showCorrectAnswers || vm.showTesteesAnswers || vm.showAnswerFeedback || vm.showPointsAwarded"
            ng-if="!vm.showCorrectAnswers || !vm.showTesteesAnswers"
            ng-model="vm.form.answers[vm.question.id].answerText"
            class="form-control"
            ></textarea>
    `
})
export default class {
    constructor (lodash, TokenService, QuestionService) {
        this.lodash = lodash;
        this.QuestionService = QuestionService;

        this.answer = {
            id: lodash.get(this.question, 'submittedAnswer.id', null),
            answerId: lodash.get(this.question, 'submittedAnswer.answerId', null),
            questionId: this.question.id,
            language: 'et',
            answerText: lodash.get(this.question, 'submittedAnswer.answerText', null)
        };

        this.form.answers[this.question.id] = this.answer;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    getPointsObtained () {
        let points = 0;
        this.lodash.forEach(this.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.questionId === this.question.id) {
                points += fsAnswer.points;
            }
        });

        if (points < 0) {
            points = 0;
        }

        return points;
    }

    getQuestionName () {
        if (this.isTrial) {
            return this.question.questionI18ns[this.selectedLanguage] ?
                this.question.questionI18ns[this.selectedLanguage].name :
                this.question.questionI18ns[this.defaultLanguage].name;
        }

        return this.question.activeI18n.name;
    }

    openImageModal (question) {
        return this.QuestionService.openImageModal(question);
    }

    openAnswerImageModal (answer, companyId) {
        return this.QuestionService.openAnswerImageModal(answer, companyId);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/freeTextPredefined/index.js